import React from "react";
import { useTranslation } from "react-i18next";
import { formatToLocalDateTime } from "../utils/formatDate";
import Loader from "../../../components/Loader";
import edit from "../../../assets/edit.png";

interface AdminTableProps {
  tableData: any;
  loading: boolean;
  handleEditEmoloyee: (id: string) => void;
}
const SalesTable: React.FC<AdminTableProps> = ({
  tableData,
  loading,
  handleEditEmoloyee,
}) => {
  const { t } = useTranslation();
  return (
    <div className="h-[65vh] md:h-[67vh] overflow-auto page-container p-2 pt-0 scrollbar scrollbar-thin">
      <table className="min-w-full bg-white border border-black-200 table-auto border-separate border-spacing-0">
        <thead className="bg-gray-200 sticky top-[0px] z-20">
          <tr>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-nowrap">
       Sales Office ID
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
           Channel ID
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
           Sales Office Name
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
          Channel Name
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
       Max Unplanned Visit
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
          Min Canton Qty
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
     Checkin Radius
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
            Persona
            </th>
           
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
            Created at
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
            Updated at
            </th>
            
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Edit
            </th>
          </tr>
        </thead>
        {loading ? (
          <tbody>
            <tr>
              <td colSpan={16} className="py-8">
                <div className="flex justify-center items-center w-full">
                  <Loader />
                </div>
              </td>
            </tr>
          </tbody>
        ) : !loading && tableData?.items?.length === 0 ? (
          <tr>
            <td colSpan={16} className="py-8 text-center text-gray-500">
              No results found
            </td>
          </tr>
        ) : (
          <tbody>
            {Array.isArray(tableData?.items) &&
              tableData.items.map((item: any, index: number) => (
                <tr key={index} className="border-b text-sm">
                  <td className="border border-gray-300 px-4 py-2">{item.sales_office_id || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.channel_id || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.sales_office_name || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.channel_name || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.max_unplanned_visits || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.min_canton_qty || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.checkin_radius || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.persona || "-"}</td>


                 
                  <td className="border border-gray-300 px-4 py-2">
                    {formatToLocalDateTime(item.created_at) || "-"}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {formatToLocalDateTime(item.updated_at) || "-"}
                  </td>
                  <td
                    onClick={() => handleEditEmoloyee(item.id)}
                    className="border border-gray-300 px-4 py-2 cursor-pointer"
                  >
                    <img className="w-4" src={edit} alt="edit" />
                  </td>
                </tr>
              ))}
          </tbody>
        )}
      </table>
    </div>
  );
};

export default SalesTable;
